import {
  ERROR_RESET,
  ERROR_SET,
  FETCH_2FA_ASYNC,
  SUBMIT_2FA_ASYNC,
  SUBMIT_EXPIRED_PASS_ASYNC,
  SUBMIT_LOGIN_ASYNC,
  SUBMIT_SSO_ASYNC,
  USE_OTHER_CREDENTIALS_ASYNC,
  VALIDATE_SESSION_ASYNC,
} from './constants'

export const validateSession = () => ({ type: VALIDATE_SESSION_ASYNC.INITIATE })
export const validateSessionSuccess = (data) => ({
  type: VALIDATE_SESSION_ASYNC.SUCCESS,
  payload: { data },
})
export const validateSessionError = (error) => ({
  type: VALIDATE_SESSION_ASYNC.ERROR,
  error,
})

export const useOtherCredentials = () => ({
  type: USE_OTHER_CREDENTIALS_ASYNC.INITIATE,
})
export const useOtherCredentialsSuccess = (data) => ({
  type: USE_OTHER_CREDENTIALS_ASYNC.SUCCESS,
  payload: { data },
})
export const useOtherCredentialsError = (error) => ({
  type: USE_OTHER_CREDENTIALS_ASYNC.ERROR,
  error,
})

export const submitLogin = (body) => ({
  type: SUBMIT_LOGIN_ASYNC.INITIATE,
  payload: { body },
})
export const submitLoginSuccess = (data) => ({
  type: SUBMIT_LOGIN_ASYNC.SUCCESS,
  payload: { data },
})
export const submitLoginError = (error) => ({
  type: SUBMIT_LOGIN_ASYNC.ERROR,
  error,
})

export const submitExpiredPass = (body) => ({
  type: SUBMIT_EXPIRED_PASS_ASYNC.INITIATE,
  payload: { body },
})
export const submitExpiredPassSuccess = (data) => ({
  type: SUBMIT_EXPIRED_PASS_ASYNC.SUCCESS,
  payload: { data },
})
export const submitExpiredPassError = (error) => ({
  type: SUBMIT_EXPIRED_PASS_ASYNC.ERROR,
  error,
})

export const submitSSO = (body) => ({
  type: SUBMIT_SSO_ASYNC.INITIATE,
  payload: { body },
})
export const submitSSOSuccess = (data) => ({
  type: SUBMIT_SSO_ASYNC.SUCCESS,
  payload: { data },
})
export const submitSSOError = (error) => ({
  type: SUBMIT_SSO_ASYNC.ERROR,
  error,
})

export const fetch2FA = () => ({ type: FETCH_2FA_ASYNC.INITIATE })
export const fetch2FASuccess = (data) => ({
  type: FETCH_2FA_ASYNC.SUCCESS,
  payload: { data },
})
export const fetch2FAError = (error) => ({ type: FETCH_2FA_ASYNC.ERROR, error })

export const submit2FA = (body) => ({
  type: SUBMIT_2FA_ASYNC.INITIATE,
  payload: { body },
})
export const submit2FASuccess = (data) => ({
  type: SUBMIT_2FA_ASYNC.SUCCESS,
  payload: { data },
})
export const submit2FAError = (error) => ({
  type: SUBMIT_2FA_ASYNC.ERROR,
  error,
})

export const setError = (error) => ({ type: ERROR_SET, payload: { error } })
export const resetError = () => ({ type: ERROR_RESET })

export default {
  // to props
  validateSession,
  useOtherCredentials,

  setError,
  resetError,

  submitLogin,
  submitExpiredPass,
  submitSSO,

  fetch2FA,
  submit2FA,
}
